import { Injectable } from '@angular/core';
import { ApiError, MessageService, notCloseMessageOptions } from '../../../../core';
import { ArquivoAuthGuardService } from './arquivo-auth-guard.service';
import { ArquivoCrudHttpService } from './arquivo-crud-http.service';
import { ArquivoPedidoHttpService } from '../pedidos/services';
import { ArquivoSearch } from '../arquivo-search';
import { isArquivoReferenciaPedidoExpedicao } from '../../referencias';
import { take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ArquivoService {

    constructor(private messageService: MessageService,
                private arquivoAuthGuardService: ArquivoAuthGuardService,
                private arquivoCrudHttpService: ArquivoCrudHttpService,
                private arquivoPedidoHttpService: ArquivoPedidoHttpService) { }


    /** Seta se um arquivo está pendente na expedição */
    private setPendenteExpedicao(idArquivo: number, pendente: boolean): Promise<ArquivoSearch> {
        return new Promise<ArquivoSearch>((resolve, reject) => {
            this.arquivoPedidoHttpService.setPendenteExpedicao(idArquivo, pendente)
            .pipe(take(1))
            .subscribe(
                arquivo => resolve(arquivo),
                (error: ApiError) => reject(error)
            );
        });
    }

    /** Abre o arquivo informado */
    open(arquivo: ArquivoSearch): Promise<ArquivoSearch> {
        return new Promise<ArquivoSearch>(async (resolve) => {
            if (!arquivo) {
                return;
            }
            window.open(arquivo.url, '_blank');

            // Pedido Pendente Expedição
            if (isArquivoReferenciaPedidoExpedicao(arquivo.referencia) && arquivo.pedidoPendenteExpedicao) {
               arquivo = await this.setPendenteExpedicao(arquivo.id, false);
            }

            resolve(arquivo);
        });
    }

    /** Imprime o arquivo informado quando compatível com impressão */
    print(arquivo: ArquivoSearch): Promise<ArquivoSearch> {
        return new Promise<ArquivoSearch>(async (resolve) => {
            if (!arquivo) {
                return;
            }

            const printWindow = window.open(arquivo.url, '_blank');
            if (printWindow) {
                setTimeout(() => {
                    printWindow.onload = () => {
                        printWindow.print();
                    };
                }, 300);
            }

            // Pedido Pendente Expedição
            if (isArquivoReferenciaPedidoExpedicao(arquivo.referencia) && arquivo.pedidoPendenteExpedicao) {
                arquivo = await this.setPendenteExpedicao(arquivo.id, false);
            }

            resolve(arquivo);
        });
    }

    /** Valida e executa a exclusão do arquivo informado */
    delete(arquivo: ArquivoSearch): Promise<ArquivoSearch> {
        return new Promise<ArquivoSearch>((resolve, reject) => {
            if (!arquivo) {
                this.messageService.warning('Verifique o arquivo que você deseja excluir e se o problema persistir entre em contato com o suporte', 'Nenhum arquivo para ser excluído', notCloseMessageOptions);
                reject();
                return false;
            }

            if (!this.arquivoAuthGuardService.canDelete(arquivo.id, arquivo.idUsuarioCreated)) {
                this.messageService.warning('Você não possui permissão para excluir este arquivo. Entre em contato com a administração para mais detalhes', 'Sem permissão', notCloseMessageOptions);
                reject();
                return false;
            }

            this.messageService.confirm(`Deseja realmente excluir o arquivo ${arquivo.nome ?? ''}?\n\nATENÇÃO: O arquivo será imediatamente excluído!`,  'Confirme').then(async result => {
                if (result) {
                    try {
                        // Excluíndo o arquivo
                        this.arquivoCrudHttpService.delete(arquivo.id)
                            .pipe(
                                take(1)
                            )
                            .subscribe(
                                () => {
                                    this.messageService.success('', `Arquivo ${arquivo.nome ?? ''} excluído com sucesso`);
                                    resolve(arquivo);
                                },
                                (error: ApiError) => reject(error)
                            );
                    } catch (error) {
                        this.messageService.error(error.message, `Erro ao excluir o arquivo ${arquivo.nome ?? ''}`, error);
                        reject();
                    }
                }
            }).
            catch(() => reject());
        });
    }
}
